export const PUBLIC_ENV_KEY = '__ENV' as const
